export default __webpack_public_path__ + "static/media/ic-safe-lock.aa36a5e8.svg";